import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const BACKDROP_HIDDEN = { opacity: 0 };
const BACKDROP_VISIBLE = { opacity: 1 };
const IMAGE_INITIAL = { opacity: 0, scale: 0.95 };
const IMAGE_ANIMATE = { opacity: 1, scale: 1 };
const IMAGE_TRANSITION = { duration: 0.4 };

export const GalleryLightbox = ({ imageUrl, index, onClose, onNext, onPrev }) => (
  <AnimatePresence>
    {imageUrl && (
      <motion.div
        initial={BACKDROP_HIDDEN}
        animate={BACKDROP_VISIBLE}
        exit={BACKDROP_HIDDEN}
        data-testid="gallery-lightbox"
        className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
      >
        <button data-testid="gallery-lightbox-close" onClick={onClose} className="absolute top-6 right-6 text-white hover:text-twp-gold">
          <X size={32} />
        </button>
        <button data-testid="gallery-lightbox-prev" onClick={onPrev} className="absolute left-4 md:left-10 text-white hover:text-twp-gold">
          <ChevronLeft size={40} />
        </button>
        <motion.img
          key={index}
          initial={IMAGE_INITIAL}
          animate={IMAGE_ANIMATE}
          transition={IMAGE_TRANSITION}
          src={imageUrl}
          alt="Vista completa"
          className="max-h-[85vh] max-w-[90vw] object-contain"
        />
        <button data-testid="gallery-lightbox-next" onClick={onNext} className="absolute right-4 md:right-10 text-white hover:text-twp-gold">
          <ChevronRight size={40} />
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);
